<ng-content></ng-content>


// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/courses/course-enroll-button/course-enroll-button.component.ts.CourseEnrollButtonComponent.html